import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-recording-player',
  templateUrl: './recording-player.component.html',
  styleUrls: ['./recording-player.component.css']
})
export class RecordingPlayerComponent implements OnInit {

  audioURL: string = "";
  selectedFileName:string = "Choose a file to play.";

  data: Array<object> = [];
  formValid: boolean = false;
  bluePrint = {};

  lambdaMessage: string = "";
  lambdaError: boolean = false;

  policyNumber = '';

  policySearchRole = environment.authRoles.policySearch;
  claimSearchRole = environment.authRoles.claimSearch;

  constructor(
    private telecomService: TelecomService,
    public auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.getRecordings();
  }

  handleButtonEvent(event){
    this.audioURL = event.item.url
  }

  getRecordings(){
    if(this.policyNumber.length < 7){
      return;
    }
    this.telecomService.getRows(environment.pcpRecordingLambdaName, {policyNumber: this.policyNumber}).then((data: any) => {
      if(data.statusCode == 200){
        //Get data put into table variable
        this.data = JSON.parse(data.body);
        for(let i=0; i<this.data.length; i++){
          this.data[i] = this.formatRow(this.data[i])
        }
        console.info(data);
        console.info(this.data);
      }
      else{
        console.error(data.Error);
      }
    });
  }

  formatRow(row){
    console.log(row.ctr.InitiationTimestamp)
    let dateTime = new Date(row.ctr.InitiationTimestamp);
    let duration = row.ctr.Agent.AgentInteractionDuration;
    let minutes = Math.floor(duration/60)
    let seconds = duration - (minutes*60)
    console.log(dateTime)
    row["timeOfCall"] = dateTime.toLocaleTimeString();
    row["dateOfCall"] = dateTime.toDateString();
    row["callLength"] = `${minutes}:${seconds}`;
    return row
  }
}
